import { useIntl } from '@capsicum/common';
import { RadioButtonInput } from '@capsicum/common-web';
import { useAmlSpendingEstimate } from '@capsicum/features/regulations/shared';

import * as S from './AmlQuestionnaire.styled';

export const SpendingEstimate = () => {
	const { $t } = useIntl();
	const { options, selectedOption, setSelectedOption } = useAmlSpendingEstimate();

	return (
		<S.Wrapper>
			<S.Question>{$t('amlQuestionnaire.spendingEstimateStep.question')}</S.Question>
			<S.RadioButtonsContainer $vertical>
				{options.map((item, index) => (
					<S.RadioButtonWrapper key={item.id}>
						<RadioButtonInput
							checked={item.id === (selectedOption as unknown as string)}
							item={item}
							pressableLabels
							testID={`aml-questionnaire-spending-estimate-radiobox${index + 1}`}
							onPress={() => setSelectedOption(item.id)}
						/>
					</S.RadioButtonWrapper>
				))}
			</S.RadioButtonsContainer>
		</S.Wrapper>
	);
};
